import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["icon", "label"];
import React from "react";
import { Box, Flex, IconAfterPay, IconAmericanExpress, IconApplePay, IconCatchCLogo, IconCreditCard, IconGooglePay, IconLatitudePay, IconMasterCard, IconPaypal, IconVisa, IconZipPay } from "@catchoftheday/cg-components";
import { PaymentIcon } from "./PaymentIcon"; // Make key of Record some of the PaymentIcon values

import { jsx as ___EmotionJSX } from "@emotion/react";
var paymentMethodIconMap = {
  CREDIT_CARD_GENERIC: {
    icon: ___EmotionJSX(IconCreditCard, null),
    showWrapper: false
  },
  CREDIT_CARD_VISA: {
    icon: ___EmotionJSX(IconVisa, null),
    showWrapper: true
  },
  CREDIT_CARD_AMEX: {
    icon: ___EmotionJSX(IconAmericanExpress, null),
    showWrapper: true
  },
  CREDIT_CARD_MASTERCARD: {
    icon: ___EmotionJSX(IconMasterCard, null),
    showWrapper: true
  },
  GIFT_CARD: {
    icon: ___EmotionJSX(IconCatchCLogo, null),
    showWrapper: true
  },
  STORE_CREDIT: {
    icon: ___EmotionJSX(IconCatchCLogo, null),
    showWrapper: true
  },
  PAYPAL: {
    icon: ___EmotionJSX(IconPaypal, null),
    showWrapper: false
  },
  ZIPPAY: {
    icon: ___EmotionJSX(IconZipPay, null),
    showWrapper: false
  },
  AFTERPAY: {
    icon: ___EmotionJSX(IconAfterPay, null),
    showWrapper: false
  },
  LATITUDEPAY: {
    icon: ___EmotionJSX(IconLatitudePay, null),
    showWrapper: false
  },
  APPLE_PAY: {
    icon: ___EmotionJSX(IconApplePay, null),
    showWrapper: false
  },
  GOOGLE_PAY: {
    icon: ___EmotionJSX(IconGooglePay, null),
    showWrapper: false
  }
};
export var PaymentMethod = function PaymentMethod(_ref) {
  var icon = _ref.icon,
      label = _ref.label,
      props = _objectWithoutProperties(_ref, _excluded);

  var mappedIcon = icon ? paymentMethodIconMap[icon] : null;
  return ___EmotionJSX(Box, _extends({
    display: "grid",
    columnGap: 4,
    gridTemplateColumns: "min-content auto"
  }, props), mappedIcon && ___EmotionJSX(PaymentIcon, _extends({
    "data-testid": "payment-method-icon"
  }, mappedIcon)), ___EmotionJSX(Flex, {
    fontSize: "base",
    fontWeight: "light",
    lineHeight: 1,
    alignItems: "center"
  }, label));
};